import { ConfigProvider } from "antd";
import React, { Suspense } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import "./App.scss";
import "./assets/css/style.css";
import config from "./config/config";
import Payment from "./containers/Payment";
import ResetPassword from "./containers/ResetPassword";
import SetPassword from "./containers/SetPassword";
import LocalAdminSetPassword from "./containers/LocalAdminSetPassword";
import PaymentStatus from "./containers/PaymentStatus";
import SuccessPaymentStatus from "./containers/SuccessPaymentStatus";
import CancelledPaymentStatus from "./containers/CancelledPaymentStatus";
import VerifyEmail from "./containers/VerifyEmail";
import Admin from "./routes/admin";
import Auth from "./routes/auth";
import ProtectedRoute from "./utils/ProtectedRoute";
const { theme } = config;

function App() {
  return (
    <ConfigProvider direction={"ltr"}>
      <ThemeProvider theme={{ ...theme }}>
        <Router>
          <div>
            <Switch>
              <Suspense
                fallback={<div className="spinner">{"Loading...."}</div>}
              >
                <Route exact path="/paypal/payment/success/:planId/:adminId/:userId" component={SetPassword} />
                <Route exact path="/" component={Auth} />
                <Route exact path="/verify-email" component={VerifyEmail} />
                <Route exact path="/payment" component={Payment} />
                <Route exact path="/reset-password" component={ResetPassword} />
                <Route exact path="/setpassword" component={LocalAdminSetPassword} />
                <Route exact path="/paypal/payment/update/success/:planId/:adminId/:userId" component={SuccessPaymentStatus} />
                <Route exact path="/paypal/payment/update/cancelled/:planId/:adminId/:userId" component={CancelledPaymentStatus} />
                <Route exact path="/paypal/payment/cancelled/:planId/:adminId/:userId" component={PaymentStatus} />
                <ProtectedRoute exact path="/admin" component={Admin} />
              </Suspense>
            </Switch>
          </div>
        </Router>
      </ThemeProvider>
    </ConfigProvider>
  );
}
export default App;
